import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '../views/landing-page.vue'

const routes = [
  { path: '/', name: 'home', component: LandingPage },
  { path: '/index', redirect: '/' },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
